import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Container, TabContainer, Nav, TabContent, TabPane } from "react-bootstrap";
import "./LevelBenefitMobile.scss";
import LoadMoreSpinner from "component/common/LoadMoreSpinner";
import { createAction, getTranslationField } from "utils";
import LevelBenefitSection from "./LevelBenefitSection";


const LevelBenefitMobile = ({
  language,
  levelBenefits,
  levelBenefitsLoading,
  level,
}) => {
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState(level);

  useEffect(() => {
    dispatch(createAction("levels/fetchLevelBenefits")());
  }, [])

  useEffect(() => {
    if (level) {
      setActiveKey(level);
    } else {
      setActiveKey(levelBenefits?.[0]?.levelId);
    }
  }, [level, levelBenefits]);

  const tabs = useMemo(() => (
    levelBenefits.map(singleLevel => ({
      key: singleLevel.levelId,
      name: getTranslationField(singleLevel, "levelName", language),
      content: <LevelBenefitSection benefits={singleLevel.levelBenefits} language={language} />
    }))
  ), [levelBenefits, language]);


  return (
    <Container className="level-benefit-mobile-page">
      {
        levelBenefitsLoading
          ? <div className="level-benefit-modal-loading">
            <LoadMoreSpinner />
          </div>
          : <TabContainer
            activeKey={activeKey}
            onSelect={(key) => { setActiveKey(key) }}
          >
            <Nav className="home-profile-custom-tab">
              {tabs.map((tab) => (
                <Nav.Item >
                  <Nav.Link className="subheading" eventKey={tab.key}>
                    {tab.name}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            <TabContent>
              {tabs.map((tab, index) => (
                <TabPane eventKey={tab.key} key={index}>
                  {tab.content}
                </TabPane>
              ))}
            </TabContent>
          </TabContainer>
      }
    </Container>
  );
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  levelBenefits: state.levels.levelBenefits,
  levelBenefitsLoading: state.levels.levelBenefitsLoading,
  level: state.users.level,
})

export default connect(mapStateToProps)(LevelBenefitMobile);
